/**
 * The mobile app sidebar (renderer/Nav.tsx) is a CSS-driven drawer toggled by a
 * hidden checkbox; there is no React state to subscribe to. These helpers let
 * other overlays cooperate with it: nothing else should open on top of the
 * drawer, and anything already open should get out of its way (#2021).
 */
export const NAV_CHECKBOX_ID = 'nav-checkbox';

function navCheckbox(): HTMLInputElement | null {
  if (typeof document === 'undefined') {
    return null;
  }
  return document.getElementById(NAV_CHECKBOX_ID) as HTMLInputElement | null;
}

/** True while the mobile sidebar drawer is open (the desktop sidebar is static). */
export function isNavDrawerOpen(): boolean {
  return !!navCheckbox()?.checked;
}

/**
 * Calls `cb` when the drawer is toggled open. Returns an unsubscribe function.
 * No-op (returns a noop) during SSR or when the sidebar isn't rendered.
 */
export function onNavDrawerOpen(cb: () => void): () => void {
  const el = navCheckbox();
  if (!el) {
    return () => {
      /* nothing to unsubscribe */
    };
  }
  const onChange = () => {
    if (el.checked) {
      cb();
    }
  };
  el.addEventListener('change', onChange);
  return () => el.removeEventListener('change', onChange);
}
